import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Modal from './../Modal/Modal.index';
import DeliveryIconsForm from './DeliveryIcons.EmailModalForm';
export const DELIVERY_ICONS_MODAL_INITIAL = 'initial';
export const DELIVERY_ICONS_MODAL_SUCCESS = 'success';
export const DELIVERY_ICONS_MODAL_FAILURE = 'failure';

class EmailModal extends React.Component {

    static propTypes = {
        modalState:    PropTypes.string,
        setModalState: PropTypes.func,
        pdfContent:    PropTypes.string
    };

    static defaultProps = {
        modalState:    null,
        setModalState: () => {},
        pdfContent:    ''
    };

    constructor(props) {
        super(props);

        this.state = {
            isModalSpinnerVisible: false
        };

        this.sendEmail = this.sendEmail.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.setModalState(null)
    }

    sendEmail() {

        this.setState({isModalSpinnerVisible: true});

        this.emailForm.refs.wrappedInstance.submit(
            (success) => {
                this.setState({isModalSpinnerVisible: false});
                if (success === true) {
                    this.props.setModalState(DELIVERY_ICONS_MODAL_SUCCESS);
                } else {
                    this.props.setModalState(DELIVERY_ICONS_MODAL_FAILURE);
                }
            },
            (error) => {
                this.setState({isModalSpinnerVisible: false});
                this.props.setModalState(DELIVERY_ICONS_MODAL_INITIAL);
            }
        )
    }

    render() {

        let responseModal;
        const showResponseModalButtons = [
            {
                text:    <FormattedMessage id="General_CoreFunctionality_UIText_general.ok" />,
                primary: true,
                click:   this.closeModal
            }
        ];

        switch (this.props.modalState) {
            case DELIVERY_ICONS_MODAL_INITIAL:
                const modalButtons = [
                    {
                        text:       <FormattedMessage id="Dashboard_SingleView_UIText_companyProfile_Email" />,
                        primary:    true,
                        click:      this.sendEmail,
                        isDisabled: this.state.isModalSpinnerVisible
                    },
                    {
                        text:       <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />,
                        primary:    false,
                        tabIndex:   1,
                        click:      this.closeModal,
                        isDisabled: this.state.isModalSpinnerVisible
                    }
                ];
                responseModal =
                    <Modal buttons={modalButtons} closeButtonHandler={!this.state.isModalSpinnerVisible ? this.closeModal : null}>
                        <h2 className="modal-header">
                            <FormattedMessage id="Entities_Preview_UIText_emailModal.emailThisArticle" />
                        </h2>
                        <div className="divider"></div>
                        <div className="modal-check">
                            <DeliveryIconsForm ref={(form) => { this.emailForm = form; }}
                                               pdfContent={this.props.pdfContent} />
                        </div>
                    </Modal>;
                break;
            case DELIVERY_ICONS_MODAL_SUCCESS:
                responseModal =
                    <Modal buttons={showResponseModalButtons} closeButtonHandler={this.closeModal}>
                        <h2 className="modal-header">
                            <span>Email This Article</span>
                        </h2>
                        <div className="divider"></div>
                        <div className="modal-check">
                            <div className="email-sent-success">
                                <FormattedMessage id="Entities_Preview_UIText_emailModal.emailSentSucessHeader" />
                            </div>
                            <div className="email-sent-description">
                                <FormattedMessage id="Entities_Preview_UIText_emailModal.emailSentSucessDescription" />
                            </div>
                        </div>
                    </Modal>;
                break;
            case DELIVERY_ICONS_MODAL_FAILURE:
                responseModal =
                    <Modal buttons={showResponseModalButtons} closeButtonHandler={this.closeModal}>
                        <h2 className="modal-header">
                            <FormattedMessage id="Entities_Preview_UIText_emailModal.emailThisArticle" />
                        </h2>
                        <div className="divider"></div>
                        <div className="modal-check">
                            <div className="email-sent-failure">
                                <FormattedMessage id="Entities_Preview_UIText_emailModal.emailSentFailureHeader" />
                            </div>
                            <div className="email-sent-failure-description">
                                <FormattedMessage id="Entities_Preview_UIText_emailModal.emailSentFailureDescription" />

                                <div>
                                    <FormattedMessage
                                        id="Authentication_Support_UIText_login.contactSupport.country.us.title" />: <a
                                        className="notranslate"
                                        href={'mailto:' + this.props.intl.formatMessage(
                                            {id: 'Authentication_Support_Authentication_Support_Link__login.contactSupport.country.us.email'})}>
                                        <FormattedMessage
                                            id="Authentication_Support_Authentication_Support_Link__login.contactSupport.country.us.email" />
                                    </a>
                                </div>
                                <div>
                                    <FormattedMessage
                                        id="Authentication_Support_UIText_login.contactSupport.country.international.title" />: <a
                                        className="notranslate"
                                        href={'mailto:' + this.props.intl.formatMessage(
                                            {id: 'Authentication_Support_Authentication_Support_Link__login.contactSupport.country.international.email'})}>
                                        <FormattedMessage
                                            id="Authentication_Support_Authentication_Support_Link__login.contactSupport.country.international.email" />
                                    </a>
                                </div>

                            </div>
                        </div>
                    </Modal>;
                break;
            default:
                responseModal = null;
        }

        return (
            <span>
                {responseModal}
            </span>
        )
    }

}

export default injectIntl(EmailModal);


// WEBPACK FOOTER //
// ./src/scripts/reusable/DeliveryIcons/DeliveryIcons.EmailModal.jsx